import { currencyServices } from "../../services/currencyservices";
const initialstate = {
    'currencies': []
}

function getcurrencies(){
   const token = localStorage.getItem('token'); // Retrieve your token
   if (token) {
        return currencyServices.getcurrency().then((response)=>{
            if(response.status == 200){
                console.log("get Currency");
                console.log(response.data);
                return response.data.data;
            }    
        }).catch(()=>{
                return [];
        });
   }else{
      return [];
   }
}

const currencyreducer = (state = initialstate,action) =>{
    switch(action.type) {
        case 'get':
              let data = getcurrencies();       
              return {...state,currencies:data};
        default:
            let data1 = getcurrencies();
           return state.currencies = data1;
        //    return state;   
    }
}

export default currencyreducer;